<p-table
  class="custom-table order-table flex-grow-1"
  [paginator]="true"
  [rows]="10"
  [loading]="loading"
  [value]="palletStockPreview"
  [scrollable]="true"
  scrollHeight="flex"
  class="custom-table order-table"
>
  <ng-template pTemplate="header">
    <tr>
      <th *ngFor="let col of columnsPreview">{{ col | stockColumn}}</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData>
    <tr >
      <td *ngFor="let col of columnsPreview">{{ rowData[col.frontEntityField] }}</td>
    </tr>
  </ng-template>
</p-table>
